module.exports = __webpack_public_path__ + "static/img/yao.2605293e.gif";